exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-box[data-v-7566db2e]{margin-top:10px}.item-box .item[data-v-7566db2e]{padding:10px 0;-webkit-box-shadow:2px 5px 20px 0 rgba(5,15,63,.1);box-shadow:2px 5px 20px 0 rgba(5,15,63,.1);border-radius:10px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:relative;margin-top:10px;cursor:pointer}.item-box .item .button-info[data-v-7566db2e]{position:absolute;top:10px;right:10px}.item-box .item .info-box[data-v-7566db2e]{padding:10px 35px;font-size:15px}", ""]);

// exports
